import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"

export default function useGetCalendar(
  params: Parameters<typeof api.cronos.user.events.getAll>[0],
) {
  const query = useQuery({
    queryKey: ["get-calendar", params],
    queryFn: () => api.cronos.user.events.getAll(params),
    refetchOnWindowFocus: false,
  })

  return query
}
